import React from 'react';

import SelectableChip from 'retired/SelectableChip';
import { truthy } from 'utils/truthy';

interface FilterOptionsProps {
  setFilterOption: (value: string) => void;
  filterOption: string;
  resetPagination: () => void;
  deedType: string;
  hasSiblingSubsidiaries: boolean;
  draftDeedsTotal: number;
  pendingDeedsTotal: number;
  sharedDeedsTotal: number;
}

const FilterOptions = ({
  setFilterOption,
  filterOption,
  resetPagination,
  deedType,
  hasSiblingSubsidiaries,
  draftDeedsTotal,
  pendingDeedsTotal,
  sharedDeedsTotal,
}: FilterOptionsProps) => {
  const options = [
    {
      name: 'All',
      value: 'all',
    },
    {
      name: 'Past',
      value: 'past',
    },
    deedType === 'Project' && {
      name: 'Ongoing',
      value: 'ongoing',
    },
    {
      name: 'Upcoming',
      value: 'upcoming',
    },
    {
      name: 'Pending review',
      value: 'pending',
      total: pendingDeedsTotal,
    },
    {
      name: 'Draft',
      value: 'draft',
      total: draftDeedsTotal,
    },
    hasSiblingSubsidiaries && {
      name: 'Shared',
      value: 'shared',
      total: sharedDeedsTotal,
    },
  ].filter(truthy);

  return (
    <div>
      {options.map((option) => {
        const onClick = () => {
          setFilterOption(option.value);
          resetPagination();
        };

        const label = (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div style={{ marginTop: 1 }}>{option.name}</div>
            {Boolean(option.total) && (
              <span
                style={{
                  display: 'flex',
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  backgroundColor: '#5559d9',
                  color: '#fff',
                  marginLeft: 6,
                  marginRight: -6,
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12,
                }}
              >
                {option.total}
              </span>
            )}
          </div>
        );

        return (
          <SelectableChip
            key={option.name}
            label={label}
            onClick={onClick}
            selected={filterOption === option.value}
          />
        );
      })}
    </div>
  );
};

export default FilterOptions;
